export default "__VITE_ASSET__BFxxz$HM__"